module.exports = __webpack_public_path__ + "img/logo_inara.1401fd86.png";